import React, {CSSProperties, useState} from 'react';
import axios from 'axios';
import {Button, Dropdown, MenuProps, message, Space, Spin} from 'antd';
import {DownOutlined, LoadingOutlined, ReloadOutlined, RightCircleOutlined} from "@ant-design/icons";

const AdminAPI = () => {

    const [isUpload, setIsUpload] = useState<boolean>(false);
    const [result, setResult] = useState<string>('');

    const [checkItem, setCheckItem] = useState<string>('');
    const [checkItemTxt, setCheckItemTxt] = useState<string>('');
    const [spinning, setSpinning] = useState<boolean>(false);

    const [fileList, setFileList] = useState<any>([]);

    const handleSubmit = async () => {
        try {
            setSpinning(true);
            const reqParam = { runCode : checkItem }
            const result = await axios.post(`/api/admin/selftest`, reqParam);
            const byteCharacters = atob(result.data);
            const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) =>
                byteCharacters.charCodeAt(i)
            );
            const byteArray = new Uint8Array(byteNumbers);

            // Blob 생성
            const blob = new Blob([byteArray], {type: "application/txt"});

            const text = await blob.text(); // Blob을 텍스트로 변환
            setResult(text); // 텍스트 상태 업데이트
            setFileList([]);
        } catch (error) {
            message.error(`통신 중 문제가 발생했습니다.`);
            setIsUpload(false);
        }
        finally {

            setIsUpload(false);
            setSpinning(false);
        }
    };

    const initText = ()=>{
        setResult('');
        setCheckItem('');
        setCheckItemTxt('');
    }


    // 텍스트에서 ':' 뒤를 스타일링 (줄바꿈을 기준으로 처리)
    // '=' 뒤 첫 번째 ':'을 찾고 그 뒤를 스타일링
    const formatText = (inputText: string) => {
        const lines = inputText.split('\n'); // 줄바꿈을 기준으로 나누기

        return lines.map((line, lineIndex) => {
            // '=' 이후의 텍스트만 찾기 위해 '='을 기준으로 분리
            const firstEqualIndex = line.indexOf('=');
            if (firstEqualIndex === -1) {
                const styleProp: CSSProperties = (line === "") ? { height: '20px' } : { height: 'auto' };
                return <div style={ styleProp } key={lineIndex}>{line}</div>; // '='가 없다면 그냥 출력
            }

            //const beforeEqual = line.substring(0, firstEqualIndex + 1); // '=' 전 텍스트
            const afterEqual = line.substring(firstEqualIndex + 1); // '=' 이후 텍스트

            // 첫 번째 ':'을 찾아 그 뒤를 스타일링
            const firstColonIndex = afterEqual.indexOf(':');
            if (firstColonIndex === -1) {
                const styleProp: CSSProperties = (line === "") ? { height: '20px' } : { height: 'auto' };
                return <div style={ styleProp } key={lineIndex}>{line}</div>; // '='가 없다면 그냥 출력// ':'가 없다면 그냥 출력
            }

            const beforeColon = afterEqual.substring(0, firstColonIndex + 1); // ':' 전 텍스트
            const afterColon = afterEqual.substring(firstColonIndex + 1); // ':' 이후 텍스트

            return (
                <div key={lineIndex}>
                    {beforeColon}
                    <span style={{ fontWeight: 'bold', color:  afterColon.trim() === '성공' ? 'blue' : 'red' }}>
                        {afterColon}
                      </span>
                </div>
            );
        });
    };

    const onClick: MenuProps['onClick'] = ({key}) => {
        initText();
        const selectData = key.split(':');
        message.info(`${selectData[1]}를 선택하셨습니다.`);
        setCheckItem(selectData[0]);
        setCheckItemTxt(selectData[1]);
    };

   /* SHA512_KAT("SHA-512 메세지 KAT (SMT, LMT) 시험"),
        SHA512_MCT("SHA-512 메세지 MCT 시험"),
        ARIA_GCM_AE("ARIA GCM AE 시험"),
        ARIA_GCM_AD("ARIA GCM AD 시험"),
        HMAC_SHA512("HMAC-SHA512 시험"),
        HASHDRBG_NO_PR_SHA512("HASHDRBG-SHA512 (예측내성 없음)시험"),
        HASHDRBG_USE_PR_SHA512("HASHDRBG-SHA512 (예측내성) 시험"),
        INVALID_MODULE("WizCryptoLib 무결성 시험");*/
    const items: MenuProps['items'] = [
        {
            label: '전체 검사',
            key: '0:전체 검사',
        },
        {
            label: 'SHA-512 메세지 KAT (SMT, LMT) 시험',
            key: '1:SHA-512 메세지 KAT (SMT, LMT) 시험',
        },
        {
            label: 'SHA-512 메세지 MCT 시험',
            key: '2:SHA-512 메세지 MCT 시험',
        },
        {
            label: 'HMAC-SHA512 시험',
            key: '3:HMAC-SHA512 시험',
        },
        {
            label: 'ARIA GCM AE 시험',
            key: '4:ARIA GCM AE 시험',
        },
        {
            label: 'ARIA GCM AD 시험',
            key: '5:ARIA GCM AD 시험',
        },
        {
            label: 'HASHDRBG-SHA512 (예측내성 없음)시험',
            key: '6:HASHDRBG-SHA512 (예측내성 없음)시험',
        },
        {
            label: 'HASHDRBG-SHA512 (예측내성) 시험',
            key: '7:HASHDRBG-SHA512 (예측내성) 시험',
        },
        {
            label: 'WizCryptoLib 무결성 시험',
            key: '8:WizCryptoLib 무결성 시험',
        },
        {
            label: '조건부 자가시험-엔트로피 건전성 시험',
            key: '9:조건부 자가시험-엔트로피 건전성 시험'
        }

    ];

    return (

        <div>
            {isUpload &&
                <div className="container">
                    <Spin indicator={<LoadingOutlined style={{ fontSize: 96 }} spin />} />
                </div>
            }
            <Dropdown menu={{ items, onClick }}>
                <a onClick={(e) => e.preventDefault()}>
                    <Space>
                        {checkItemTxt || '검사할 항목을 선택해주세요'}    <DownOutlined />
                    </Space>
                </a>
            </Dropdown>
            {checkItemTxt &&
                <div style={{marginTop: "30px"}}>
                    <Button onClick={handleSubmit} icon={<RightCircleOutlined />}>{checkItemTxt} 실행</Button>
                    {result.length > 0 && <Button style={{marginLeft:'10px'}} onClick={initText} icon={<ReloadOutlined />}>초기화</Button>}
                </div>
            }

            {result.length > 0 &&
                <div style={{marginTop: "20px",
                    whiteSpace: 'pre-wrap'}}>
                    {formatText(result)}
                </div>
            }
            <Spin spinning={spinning} fullscreen />
        </div>
    );
};

export default AdminAPI;
